export function common() {
  const header = document.getElementById("js-header");

  // ヘッダースクロール処理
  const headerScroll = () => {
    if (header) { // headerが存在する場合のみ処理
      window.addEventListener("scroll", () => {
        if (window.scrollY > 1 && window.innerWidth > 768) {
          header.classList.add("is-scroll");
        } else {
          header.classList.remove("is-scroll");
        }
      });
    }
  };

  headerScroll();

  (function ($) {
    $(document).ready(function () {
      const splashTextElement = document.getElementById("splash_text");

      // splash_textが存在しない場合は処理をスキップ
      if (!splashTextElement) {
        console.warn("#splash_text 要素が見つかりません。処理をスキップします。");
        return;
      }

      // テキストのカウントアップ+バーの設定
      var bar = new ProgressBar.Line(splashTextElement, { // id名を指定
        easing: 'easeInOut', // アニメーション効果linear、easeIn、easeOut、easeInOutが指定可能
        duration: 1000, // 時間指定(1000＝1秒)
        strokeWidth: 0.2, // 進捗ゲージの太さ
        color: '#555', // 進捗ゲージのカラー
        trailWidth: 0.2, // ゲージベースの線の太さ
        trailColor: '#bbb', // ゲージベースの線のカラー
        text: { // テキストの形状を直接指定
          style: { // 天地中央に配置
            position: 'absolute',
            left: '50%',
            top: '50%',
            padding: '0',
            margin: '-30px 0 0 0', // バーより上に配置
            transform: 'translate(-50%,-50%)',
            'font-size': '1rem',
            color: '#fff',
          },
          autoStyleContainer: false // 自動付与のスタイルを切る
        },
        step: function (state, bar) {
          bar.setText(Math.round(bar.value() * 100) + ' %'); // テキストの数値
        }
      });

      // アニメーションスタート
      bar.animate(1.0, function () { // バーを描画する割合を指定します 1.0 なら100%まで描画します
        console.log("Animation complete, starting fade out"); // デバッグ用コンソールログ
        $("#splash").delay(500).fadeOut(800, function () {
          console.log("Fade out complete"); // デバッグ用コンソールログ
        }); // アニメーションが終わったら#splashエリアをフェードアウト
      });
    });
  })(jQuery);
}
